import { isEmpty } from 'lodash';

interface PlayerVolume {
    volume: number;
    muted: boolean;
}

const NIKE_PLAYER_VOLUME_LS_KEY = 'player-volume';

const NIKE_PLAYER_VOLUME_DEFAULT: PlayerVolume = {
    muted: false,
    volume: 50
};

export const getPlayerVolumeState = () => {
    const persisted = readPersistedPlayerState();
    if (!isEmpty(persisted)) {
        return persisted;
    }

    return updatePlayerVolumeState(NIKE_PLAYER_VOLUME_DEFAULT);
};

export const onPlayerVolumeChange = (volume: number) => updatePlayerVolumeState({ volume });
export const onPlayerMuteChange = (muted: boolean) => updatePlayerVolumeState({ muted });

export const updatePlayerVolumeState = (playerVolumeState: Partial<PlayerVolume> = {}): PlayerVolume => {
    const _updated = Object.assign(NIKE_PLAYER_VOLUME_DEFAULT, readPersistedPlayerState(), playerVolumeState);

    localStorage.setItem(NIKE_PLAYER_VOLUME_LS_KEY, JSON.stringify(_updated));
    return _updated;
};

const readPersistedPlayerState = () => {
    let storedPlayerVolume = localStorage.getItem(NIKE_PLAYER_VOLUME_LS_KEY);

    if (storedPlayerVolume) {
        try {
            return JSON.parse(storedPlayerVolume) as PlayerVolume;
        } catch (e) {}
    }

    return NIKE_PLAYER_VOLUME_DEFAULT;
};
